export default "__VITE_PUBLIC_ASSET__868df6ab__"